import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { adminApi as api } from "../../../../util/api";
import { snakifyKeys } from "../../../../util/helpers";
import { FollowupTaskConfigForm } from "./FollowupTaskConfigForm";

export const CreateFollowupTaskConfigModal = ({ onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    setError(null);

    try {
      const res = await api.post("/admin/followup_task_configs", snakifyKeys({ followupTaskConfig: values }));

      if (onCreate) {
        onCreate(res.data.resources);
      }

      setOpen(false);
    } catch (err) {
      setError(err);
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Follow-up Task Config
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Follow-up Task Configuration</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{ workflow: "prior_auth" }}>
            {(props) => <FollowupTaskConfigForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
